import { Select$ChangeEvent } from "sap/m/Select";
import BaseController from "./BaseController";
import { ThemeSelector } from "../service/ThemeSelector.service";
import { SettingsService } from "../service/Settings.service";
import { Switch$ChangeEvent } from "sap/m/Switch";
import JSONModel from "sap/ui/model/json/JSONModel";
import { Slider$ChangeEvent } from "sap/m/Slider";

/**
 * @namespace com.unitrade.crm.controller
 */
export default class Settings extends BaseController {
  private _service: SettingsService;
  private _oModel: JSONModel;
  onInit(): void {
    this._service = new SettingsService();
    const userConfig = this._service.getUserConfiguration();
    this._oModel = new JSONModel({
      experimentalEnabled: userConfig.experimentalFeaturesEnabled,
      birthdayReminderActive: this._service.getBirthdayReminderActive(),
      selectedTheme: ThemeSelector.getTheme(),
      selectedUtaBackend: this._service.getSetting("uta-backend") ?? "openai",
      selectedUtaAvatar: this._service.getSetting("uta-avatar") ?? "/assets/uta_final.jpg",
      selectedUtaAvatarSize: this._service.getSetting("uta-avatar-size") ?? "S",
      selectedUtaVoice: this._service.getSetting("uta-voice") ?? "de-DE-SeraphinaMultilingualNeural",
      selectedUtaVoiceSpeed: parseInt(this._service.getSetting("uta-voice-speed") ?? "0"),
      selectedUtaTextToSpeech: this._service.getSetting("uta-voice-enabled") ?? "wheninputspeech",
      selectedTtsProvider: this._service.getSetting("tts-provider") ?? "azure",
    });
    this.setModel(this._oModel);
  }

  onThemeChanged = (oEvent: Select$ChangeEvent) => {
    const selected = oEvent.getParameter("selectedItem");
    ThemeSelector.setTheme(selected.getKey());
  };

  onBirthdayReminderChanged = (oEvent: Switch$ChangeEvent) => {
    const enabled = oEvent.getParameter("state");
    this._service.setBirthdayReminderActive(enabled);
    this._oModel.setProperty("/birthdayReminderActive", enabled);
  };

  onUtaAvatarSize = (oEvent: Select$ChangeEvent) => {
    const selectedItem = oEvent.getParameter("selectedItem");
    this._service.setSetting("uta-avatar-size", selectedItem.getKey());
  };

  onUtaAvatarVoiceChange = (oEvent: Select$ChangeEvent) => {
    const selectedItem = oEvent.getParameter("selectedItem");
    this._service.setSetting("uta-voice", selectedItem.getKey());
  };

  onUtaVoiceSpeedChange = (oEvent: Slider$ChangeEvent) => {
    const speed = oEvent.getParameter("value");
    this._service.setSetting("uta-voice-speed", speed.toString());
  };

  onUtaTextToSpeechChange = (oEvent: Select$ChangeEvent) => {
    const tts = oEvent.getParameter("selectedItem");
    this._service.setSetting("uta-voice-enabled", tts.getKey());
  };
}
